import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import LogList from '../components/LogList';

import { listenLogs, unlistenLogs } from '../services/actions';
import { selectLogs, selectLogsPending } from '../services/selectors';

export default compose(
    connect(
        state => ({
            showLoader: selectLogsPending(state),
            logs: selectLogs(state),
        }),
        (dispatch, { importId }) => ({
            read: () => {
                if (importId) {
                    dispatch(listenLogs(importId));
                }
            },
            clear: () => {
                if (importId) {
                    dispatch(unlistenLogs(importId));
                }
            },
        }),
    ),
    routeDependencies({
        shouldReRoute: (oldProps, newProps) => oldProps.importId !== newProps.importId,
    }),
    loadable,
)(LogList);
